import LoadingSpinner from '@/components/ui/loading-spinner';
import DetailFieldsCard, { DetailField } from '@/components/DetailFieldsCard';
import { useStudy } from '@/hooks/studies/useStudy';
import { getEntityStatusInfo } from '@/utils/entityStatuses';
import { formatTimestamp } from '@/utils/dates';

const StudyDetailsContent = ({ studyId }: { studyId: string }) => {
  const { data: study, isLoading } = useStudy(studyId);
  const statusInfo = study?.status ? getEntityStatusInfo(study.status) : null;

  if (isLoading) return <LoadingSpinner />;

  const fields: DetailField[] = [
    { label: 'Protocol Number', value: study?.protocol_number },
    {
      label: 'Status',
      render: statusInfo ? (
        <div className="inline-flex items-center gap-2">
          <div
            className="w-2 h-2 rounded-full"
            style={{ backgroundColor: statusInfo.color }}
          />
          <span className="text-gray-900">{statusInfo.label}</span>
        </div>
      ) : undefined,
    },
    { label: 'Sponsor', value: study?.sponsor_name },
    { label: 'CRO', value: study?.cro_name },
    { label: 'Variant', value: study?.submission_template?.variant },
    { label: 'Protocol Title', value: study?.protocol_title },
    { label: 'PI Name', value: study?.pi_name },
    { label: 'Category', value: study?.submission_template?.category },
    { label: 'Sub-Category', value: study?.submission_template?.sub_category },
    { label: 'Created', value: formatTimestamp(study?.created_at) },
    { label: 'Submitted', value: formatTimestamp(study?.submitted_at) },
    { label: 'Expiration', value: formatTimestamp(study?.expiration_date) },
    { label: 'Last Updated', value: formatTimestamp(study?.updated_at) },
  ];

  return (
    <div className="space-y-6">
      <DetailFieldsCard title="Study Details" fields={fields} />
    </div>
  );
};

export default StudyDetailsContent;
